import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=54d9bedc&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=54d9bedc&prod&lang=scss&scoped=true"
import style1 from "./TopNav.vue?vue&type=style&index=1&id=54d9bedc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9bedc",
  null
  
)

export default component.exports